import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const rpShiftTimingConfigAPI = () => {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAllRpShiftTimingsAPI() {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
         
          const res = await fetch(
            `${config.host}/panel/rp/shiftTimings/getAll`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function createRpShiftTimingsAPI(values) {
        try {
          const obj = {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
          };
         
          const res = await fetch(
           `${config.host}/panel/rp/shiftTimings/create`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      } 

      async function updateRpShiftTimingsAPI(values) {
        try {
          const obj = {
            method: "PUT",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
          };
          const res = await fetch(
            `${config.host}/panel/rp/shiftTimings/update`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    
    return{
        getAllRpShiftTimingsAPI,
        createRpShiftTimingsAPI,
        updateRpShiftTimingsAPI,
       
       
    }
}
export default rpShiftTimingConfigAPI;
